"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var REFRESH_VOD_PLAYBACK_HEARTBEAT = function () { return "mutation VodPlaybackHeartbeat($assetId: ID!, $deviceId: ID!) {\n  vodPlaybackHeartbeat(assetId: $assetId, deviceId: $deviceId) {\n    timeToNextHeartbeat\n  }\n}"; };
exports.default = REFRESH_VOD_PLAYBACK_HEARTBEAT;
//# sourceMappingURL=refreshVodPlaybackHeartbeat.js.map